import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import UserService from '@/services/UserService'
// import { Store } from 'vuex';
import store from '@/store';

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'history', //hash
  linkActiveClass: 'active',
  routes: paths
});
// router gards
router.beforeEach((to, from, next) => {

  // console.log(to.matched)
  if (to.matched.some(record => record.meta.requiresAuth) && !UserService.isLogin()) {
    next({ name: 'Login' })
  } else {


    NProgress.start();
    next()
  }
});

router.afterEach((to, from) => {
  // ...
  if (to.meta.requiresAuth) {
    //console.log(to)
    // check userDetail state notfound
    if (Object.keys(store.state.authen.userDetail) <= 0) {
      
      console.log("Load/UserDetail")
      store.dispatch('authen/getUserDetail')
    }
    
    // if (store.state.authen.userDetail) {
    //   store.dispatch('authen/getUserDetail');
    // }
  }



  NProgress.done();
});

export default router;
